import { useQuery } from "@tanstack/react-query";

import type { TechnicusCampaignIntegrationsResponse } from "./types";
import { campaignIntegrationQueryKeys } from "../query-keys";

import { instance } from "@/lib/axios/instance";

type UseTechnicusCampaignIntegrationsParams = {
  clientId: string | undefined;
  search?: string;
  statusFilter?: string;
  page?: number;
  pageSize?: number;
};

export function useTechnicusCampaignIntegrations({
  clientId,
  search,
  statusFilter,
  page = 1,
  pageSize = 50,
}: UseTechnicusCampaignIntegrationsParams) {
  return useQuery({
    queryKey: campaignIntegrationQueryKeys.overviewList({
      integrationName: "technicus",
      clientId: clientId ?? "",
      search,
      statusFilter,
      page,
      pageSize,
    }),
    queryFn: async () => {
      const response = await instance.get<{
        data: TechnicusCampaignIntegrationsResponse[];
        page: number;
        pageSize: number;
        totalRecords: number;
      }>("/api/v2/Integrations/technicus/campaigns/overview", {
        params: {
          clientId,
          search: search || undefined,
          statusFilter: statusFilter || undefined,
          page,
          pageSize,
        },
      });

      // Entity strategy wraps the response in PaginatedResponse.Data[0]
      return response.data.data[0] ?? null;
    },
    enabled: !!clientId,
  });
}
